import { useSuspenseQuery } from "@tanstack/react-query";
import { create, keyResolver, windowScheduler } from "@yornaath/batshit";
import { Api } from "@/api.config";
import { QueryKeys } from "@/LinkGen";

const batcher = create({
  fetcher: async (IDs: number[]) => {
    return Api.Upload(IDs).then((x) => x.data);
  },
  resolver: keyResolver("ID"),
  scheduler: windowScheduler(50),
});

export function useUpload(ID: number) {
  const { data } = useSuspenseQuery({
    queryKey: QueryKeys.Upload(ID),
    queryFn: () => batcher.fetch(ID),
  });

  return data;
}
